import { render, staticRenderFns } from "./MessageCommentsItem.vue?vue&type=template&id=2c9b341c&scoped=true&"
import script from "./MessageCommentsItem.vue?vue&type=script&lang=js&"
export * from "./MessageCommentsItem.vue?vue&type=script&lang=js&"
import style0 from "./MessageCommentsItem.vue?vue&type=style&index=0&id=2c9b341c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9b341c",
  null
  
)

export default component.exports